import type { FilterColumnType } from './operators';

/** Фильтруемые столбцы каталога чтецов (ключ = id колонки в readersTableLayout). */
export const READERS_CATALOG_COLUMN_FILTER_TYPES: Partial<Record<string, FilterColumnType>> = {
  state: 'select',
  name: 'text',
  studio: 'text',
  legal_entity: 'text',
  reader_price: 'number',
};
